import { ToolsRoot, UnsafeScreenRoot } from "types";

export const ToolsRootDefinition: UnsafeScreenRoot = {
  name: ToolsRoot,
  routePath: ["/admin/*"],
};
